import http from './webhook/httpconfig'
import store from '@/store'
import { cancelHTTPRequests } from '@/services/utils'
import { generateHeaders } from './webhook/webhook'
import { getCookie } from './cookie'
import { cookieConstant } from './constants'

export default async function getAWSCredentials () {
  const result  = await http.request({
    method: 'get',
    url: '/api/v2/mqtt',
    headers: {
      'Content-Type': 'application/json',
      'x-bot-ref-id': store?.getters?.getBotRefId,
      'is-prompt-testing-enable': store?.getters?.isPromptTestingEnable,
      'x-conversation-id': getCookie(cookieConstant.SESSION.CONVERSATION_ID),
      ...generateHeaders()
    },
    cancelToken: cancelHTTPRequests()
  })
  return result
}
